import { concat } from '@/helpers/string';

export const formatNir = (value?: string): string => {
	if (!value) return '';
	const nirRegex =
		/^(\d{1})\s*(\d{2})?\s*(\d{2})?\s*(\w{2})?\s*(\d{3})?\s*(\d{3})?$/;
	const regExec = nirRegex.exec(value);

	if (!regExec) return value;
	const formattedValue = concat(regExec?.slice(1), ' ');
	return formattedValue;
};

export const computeNirKey = (nir: string) => {
	if (!nir) return '';
	// If nir field is fully filled -> fill nirKey field and focus it.
	if (nir.replaceAll(/\s/g, '').length >= 13) {
		// Replace Corse ZIP by numbers.
		const convertedNir = nir
			.replaceAll(/\s/g, '')
			.toLowerCase()
			.replace('2b', '18')
			.replace('2a', '19');
		// Nir key formula.
		const computedKey = 97 - (Number.parseInt(convertedNir, 10) % 97);
		return String(computedKey).padStart(2, '0');
	}
	return '';
};

export const formatSIRET = (value?: string): string => {
	if (!value) return '';
	const siretRegex = /^(\d{3})\s*(\d{3})?\s*(\d{3})?\s*(\d{5})?\s*$/;
	const regExec = siretRegex.exec(value);

	if (!regExec) return value;
	const formattedValue = concat(regExec?.slice(1), ' ');
	return formattedValue;
};
